import { useGetFailedCommercePaymentsQuery } from '../../__generated__/chirp/com/hubspot/commerce/buyer/portal/rpc/BuyerBillingDataRpc.hooks';
// TODO: import useGetFailedCommercePaymentsQuery from BuyerPreviewDataRpc.hooks once BE adds the RPC
import { useAppSelector } from '../redux';
import { selectIsPreview } from '../features/PreviewSlice/PreviewSelectors';
export function useFailedPaymentsData() {
  const isPreview = useAppSelector(selectIsPreview);

  // TODO: add preview query via BuyerPreviewDataRpc once BE adds getFailedCommercePayments,
  // mirroring the pattern in useCommercePaymentsData / useInvoicesData
  const {
    loading,
    error,
    data
  } = useGetFailedCommercePaymentsQuery({
    skip: isPreview,
    fetchPolicy: 'cache-and-network'
  });
  if (isPreview) {
    return {
      loading: false,
      error: undefined,
      data: undefined
    };
  }
  return {
    loading,
    error,
    data
  };
}